import axios from 'axios';

// Configure API base URL based on environment
const getBaseURL = () => {
  // In development, use the proxy setup (package.json has proxy to localhost:8888 for MAMP)
  if (process.env.NODE_ENV === 'development') {
    return ''; // Empty string uses the proxy configured in package.json (MAMP on port 8888)
  }
  
  // In production, try the standard backend path first
  // If mod_rewrite doesn't work, you can change this to '/backend/api.php'
  return '/backend';
};

// Create axios instance with base configuration
const api = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for debugging
api.interceptors.request.use(
  (config) => {
    console.log(`API Request: ${config.method?.toUpperCase()} ${config.baseURL}${config.url}`);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('API Error:', error.response?.status, error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default api;